import UserForm from "./Form";
import UserList from "./UserList";
import UserDetail from "./UserDetail";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Spinner from "@components/Spinner/Spinner";
import ServerError from "@components/Error/ServerError";
import Breadcrumb from "@components/Breadcrumb/Breadcrumb";
import AddButton from "@components/Button/AddButton";
import useMatchedElementHeight from "@hooks/useMatchedElementHeight";
import { usePaginatedUsers } from "@hooks/usePaginatedData";

export default function UserPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [isUpdate, setIsUpdate] = useState(false);
  const [typeDetail, setTypeDetail] = useState();
  const [openForm, setOpenForm] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [search, setSearch] = useState("");
  const [ordering, setOrdering] = useState("");

  const {
    data: userResponse,
    isLoading,
    isError,
  } = usePaginatedUsers({
    page,
    pageSize,
    search,
    ordering,
  });

  const userData = userResponse?.results || [];
  const totalCount = userResponse?.count || 0;
  const hasNext = !!userResponse?.next;
  const hasPrevious = !!userResponse?.previous;
  const listColumnRef = React.useRef(null);
  const detailHeight = useMatchedElementHeight(listColumnRef, ".table-wrapper", Boolean(id));

  const handleClose = () => {
    setOpenForm(false);
    setIsUpdate(false);
  };

  if (isLoading) return <Spinner height={"80vh"} />;
  if (isError) return <ServerError />;

  return (
    <>
      <Breadcrumb
        title={t("users")}
        addButton={<AddButton label={"add_user"} action={() => setOpenForm(true)} />}
      />
      <Container className="entity-list-page">
        <Row className="g-3 entity-split-row">
          <Col ref={listColumnRef} lg={id ? 6 : 12} className="entity-master-column">
            <UserList
              users={userData}
              setIsUpdate={setIsUpdate}
              setTypeDetail={setTypeDetail}
              handleShow={() => setOpenForm(true)}
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              search={search}
              setSearch={setSearch}
              ordering={ordering}
              setOrdering={setOrdering}
              totalCount={totalCount}
              hasNext={hasNext}
              hasPrevious={hasPrevious}
              isLoading={isLoading}
            />
          </Col>
          {id && (
            <Col lg={6} className="entity-detail-column">
              <div
                className="entity-detail-height-shell"
                style={detailHeight ? { height: `${detailHeight}px` } : undefined}
              >
                <UserDetail />
              </div>
            </Col>
          )}
        </Row>
        {openForm && (
          <UserForm
            show={openForm}
            isUpdate={isUpdate}
            typeDetail={typeDetail}
            handleClose={handleClose}
          />
        )}
      </Container>
    </>
  );
}
